import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import AppFooter from '../organisms/app-footer.component';
import AppHeader from '../organisms/app-header.component';
import EntryPage from '../pages/entry';
import EntryContext from '../pages/entry/entry-context';
import JobPage from '../pages/job';
import { Picklist } from '../services/picklist/interfaces/picklist.interface';
import { RecruitEntry } from '../services/recruit-entry/recruit-entry.interface';

export default function AppLayout() {
  const [data, setData] = useState<RecruitEntry>();
  const [picklist, setPicklist] = useState<Picklist[]>();

  return (
    <>
      {AppHeader()}

      <div className="main-content">
        <Switch>
          <EntryContext.Provider
            value={{
              data,
              setData,
              picklist,
              setPicklist,
            }}
          >
            <Route exact path="/" component={JobPage} />
            <Route path="/job" component={JobPage} />
            <Route path="/index.html" component={JobPage} />
            <Route path="/entry" component={() => <EntryPage />} />
          </EntryContext.Provider>
        </Switch>
      </div>
      
      {AppFooter()}
    </>
  );
}